import { render, staticRenderFns } from "./EstablishmentCard.vue?vue&type=template&id=e0964dd8&scoped=true&lang=html&"
import script from "./EstablishmentCard.vue?vue&type=script&lang=coffee&"
export * from "./EstablishmentCard.vue?vue&type=script&lang=coffee&"
import style0 from "./EstablishmentCard.vue?vue&type=style&index=0&id=e0964dd8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0964dd8",
  null
  
)

component.options.__file = "EstablishmentCard.vue"
export default component.exports